import { Component, Input } from '@angular/core';

@Component({
  selector: 'aas-phone-value',
  templateUrl: './phone-value.component.html'
})
export class PhoneValueComponent {

  @Input() id: string;
  @Input() value: string;

  constructor() { }
}
